@if (isEditing()) {
  <input
    class="ride-name-input"
    [ngModel]="inputValue()"
    (ngModelChange)="inputValue.set($event)"
    (blur)="save()"
    (keydown.enter)="save()"
    (keydown.escape)="cancel()"
    autofocus />
} @else {
  <h2 class="ride-name" (click)="startEditing()" title="Klikni za uređivanje">
    {{ currentName() }}
    <span class="edit-icon">✎</span>
  </h2>
}